import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function SheetBillsCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-sheetbills"
      eyebrow="Selected work"
      tag="SheetBills"
      title="SheetBills — Google Sheets Invoicing Software"
      summary="A product-led invoicing flow that turns spreadsheet rows into client-ready invoices. Clean UX, fast setup, and a polished output that makes small teams look enterprise."
      image="/image.png"
      imageAlt="SheetBills landing and invoicing preview UI"
      sections={[
        {
          title: "The ask",
          body: "Build a simple, reliable way for users to generate professional invoices directly from Google Sheets—without messy templates, manual copy/paste, or design skills.",
        },
        {
          title: "What we shipped",
          body: "A streamlined invoice builder with sheet import, live preview, and flexible branding controls—optimized for speed, clarity, and “done in minutes” usability.",
        },
        {
          title: "Why it works",
          body: "Every step reduces friction: the user starts where they already are (Sheets), sees results instantly (preview), and finishes with a client-ready document (export/share).",
        },
      ]}
      tech={["React", "Node.js", "Google Sheets", "UX/UI", "Figma"]}
      results={[
        "Sheets → invoice in minutes",
        "Live preview experience",
        "Brand-ready output",
        "Conversion-focused flow",
      ]}
    />
  )
}

